module.exports = __webpack_public_path__ + "img/fil.1ca7e9aa.svg";